/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S8_P_Li3Inputs */

const tr_mesafeli_s8_p_li3 = /** @type {(inputs: Mesafeli_S8_P_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planlı bakımları en az 72 saat önceden duyurmak ve düşük kullanım saatlerinde gerçekleştirmek.`)
};

const en_mesafeli_s8_p_li3 = /** @type {(inputs: Mesafeli_S8_P_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To announce planned maintenance at least 72 hours in advance and to carry it out during low usage hours.`)
};

const de_mesafeli_s8_p_li3 = /** @type {(inputs: Mesafeli_S8_P_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplante Wartungen mindestens 72 Stunden im Voraus ankündigen und in Zeiten geringer Nutzung durchführen.`)
};

const ru_mesafeli_s8_p_li3 = /** @type {(inputs: Mesafeli_S8_P_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объявлять о плановых работах не менее чем за 72 часа и проводить их в часы низкой нагрузки.`)
};

/**
* | output |
* | --- |
* | "To announce planned maintenance at least 72 hours in advance and to carry it out during low usage hours." |
*
* @param {Mesafeli_S8_P_Li3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s8_p_li3 = /** @type {((inputs?: Mesafeli_S8_P_Li3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S8_P_Li3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s8_p_li3(inputs)
	if (locale === "de") return de_mesafeli_s8_p_li3(inputs)
	if (locale === "ru") return ru_mesafeli_s8_p_li3(inputs)
	return tr_mesafeli_s8_p_li3(inputs)
});